import './pa_section_style.scss';
import { Link } from 'react-router-dom';
import { removeBaseUrl } from '../../utils';
export const PracticeAreasSection = ({
    fields
}) => {
    return <section id="pa-section" className="home-section">
        <div className="container">
            <div className='section-header'>
                <h2>{ fields?.pa_section_title ?? 'Practice Areas'}</h2>
                <p>{ fields?.pa_section_description ?? 'Joseph T. Mullen, Jr. & Associates is a full-service New York City personal injury firm, that specializes in all areas of personal injury, medical malpractice and wrongful death law, as well as all other legal matters. Our resources and scope enable us to take on even the most complex cases for our clients. We believe in treating clients with respect and compassion, and zealously fighting for the highest possible fair compensation.'}</p>
            </div>

            <div className='pa-wrapper'>
                <div className='pa-repeater'>
                    {
                        fields?.pa_repeater?.map((it, index) => <div className='pa-block-item' key={index}>
                            <span className='block-icon' dangerouslySetInnerHTML={{ __html: it.block_icon }}></span>
                            <span className='block-name'>{ it?.block_title }</span>
                            <Link to={removeBaseUrl(it?.block_link)}></Link>
                        </div>)
                    }
                </div>
            </div>
            <div className='more-link'>
                <Link to="/practice-areas/" className="button">See All Our Practice Areas</Link>
            </div>
        </div>
    </section>
}